import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { LayoutContext } from 'contexts/LayoutContext';
import { View } from 'dripsy';

import { useCallback, useContext, useEffect, useState } from 'react';
import { AccountManagementStackRoutes, AccountManagementStackScreenProps } from '../../account.navigator';
import { ModalContainerView } from '../../components/ModalContainerView';
import { SetCardLimitMain } from './SetCardLimitMain';
import { SetCardLimitDailyPurchaseLimit } from './SetCardLimitDailyPurchaseLimit';
import { SetCardLimitConfirmation } from './SetCardLimitConfirmation';
import { SetCardLimitPlaced } from './SetCardLimitPlaced';

import { SetCardLimitStackParamList, SetCardLimitStackRoutes } from './type';

const SetCardLimitStack = createNativeStackNavigator<SetCardLimitStackParamList>();

export const SetCardLimitNavigator: React.FC<AccountManagementStackScreenProps<AccountManagementStackRoutes.SetCardLimit>> = ({
  route
}) => {
  const { account, tab, record, func, actionResponse, actionError, refresh } = route.params;
  const [dimensions, setDimensions] = useState({ width: 0, height: 0 });
  const layout = useContext(LayoutContext);

  useEffect(() => {
    if (!layout.isMobile) return;
    setDimensions(layout.dimensions);
  }, [layout.dimensions]);

  const onLayout = useCallback((event) => {
    const { width, height } = event.nativeEvent.layout;
    setDimensions({ width, height });
  }, []);

  const [data, setData] = useState(undefined);
  const onData = (data: any) => {
    setData(data);
  };

  const [dailyLimitType, setDailyLimitType] = useState<string | undefined>();
  const onDailyLimitType = (value: string | undefined) => {
    setDailyLimitType(value);
  };

  const [returnData, setReturnData] = useState(undefined);
  const onReturnData = (data: any) => {
    setReturnData(data);
  };

  return (
    <ModalContainerView dimensions={dimensions}>
      <View sx={{ height: dimensions.height, width: dimensions.width }} onLayout={onLayout}>
        <SetCardLimitStack.Navigator
          initialRouteName={SetCardLimitStackRoutes.Main}
          screenOptions={{
            presentation: layout.isMobile ? 'modal' : 'transparentModal',
            headerShown: false
          }}>
          <SetCardLimitStack.Screen
            name={SetCardLimitStackRoutes.Main}
            component={SetCardLimitMain}
            initialParams={{ onLayout, onDailyLimitType, account, tab, record, func, refresh }}
            options={{ headerShown: false }}
          />
          <SetCardLimitStack.Screen
            name={SetCardLimitStackRoutes.DailyPurchaseLimit}
            component={SetCardLimitDailyPurchaseLimit}
            initialParams={{ onLayout, onData, account, tab, dailyLimitType, record, func, onReturnData, refresh }}
            options={{
              presentation: layout.isMobile ? 'modal' : 'transparentModal',
              headerShown: false
            }}
          />
          <SetCardLimitStack.Screen
            name={SetCardLimitStackRoutes.Confirmation}
            component={SetCardLimitConfirmation}
            initialParams={{ onLayout, data, account, tab, dailyLimitType, record, func, onReturnData, refresh }}
            options={{
              presentation: 'transparentModal',
              headerShown: false,
              contentStyle: {
                backgroundColor: 'transparent'
              }
            }}
          />
          <SetCardLimitStack.Screen
            name={SetCardLimitStackRoutes.Placed}
            component={SetCardLimitPlaced}
            initialParams={{ onLayout, data, account, tab, dailyLimitType, record, returnData, refresh }}
            options={{ presentation: layout.isMobile ? 'modal' : 'transparentModal', headerShown: false }}
          />
        </SetCardLimitStack.Navigator>
      </View>
    </ModalContainerView>
  );
};
